import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft, Shield, Lock, Eye, Database, Cookie, UserCheck, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
export const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="bg-black text-white w-full min-h-screen overflow-x-hidden" data-id="element-395">
      <Header data-id="element-396" />
      <main className="pt-32 pb-24" data-id="element-397">
        {/* Background elements */}
        <div className="fixed inset-0 -z-10" data-id="element-398">
          <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-900/50 to-black" data-id="element-399"></div>
          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/asfalt-dark.png')] opacity-30" data-id="element-400"></div>
          {/* Grid pattern overlay */}
          <div className="absolute inset-0" data-id="element-401">
            <div className="w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAwIDEwIEwgNDAgMTAgTSAxMCAwIEwgMTAgNDAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSg1OSwgMTIzLCAyNTMsIDAuMSkiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIgLz48L3N2Zz4=')] opacity-20" data-id="element-402"></div>
          </div>
          {/* Glowing orbs */}
          <div className="absolute inset-0 overflow-hidden" data-id="element-403">
            <div className="absolute w-96 h-96 rounded-full bg-blue-primary/5 blur-3xl animate-pulse" style={{
            top: '20%',
            left: '10%',
            animationDuration: '15s'
          }} data-id="element-404"></div>
            <div className="absolute w-96 h-96 rounded-full bg-blue-light/5 blur-3xl animate-pulse" style={{
            bottom: '10%',
            right: '10%',
            animationDuration: '20s'
          }} data-id="element-405"></div>
          </div>
        </div>
        <div className="container mx-auto px-4 relative" data-id="element-406">
          <Link to="/" className="inline-flex items-center text-blue-light hover:text-blue-primary transition-colors mb-8" data-id="element-407">
            <ArrowLeft size={16} className="mr-2" data-id="element-408" />
            Back to Home
          </Link>
          <div className="max-w-4xl mx-auto" data-id="element-409">
            <h1 className="text-3xl md:text-5xl font-bold mb-8 animate-fadeIn" data-id="element-410">
              Privacy <span className="text-blue-light" data-id="element-411">Policy</span>
            </h1>
            <div className="text-gray-300 space-y-10" data-id="element-412">
              <div className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-xl p-6 shadow-lg" data-id="element-413">
                <p className="mb-4 text-sm text-gray-400" data-id="element-414">
                  Last Updated: Sept 26, 2025
                </p>
                <p className="mb-6" data-id="element-415">
                  At Callvana, we value your privacy and are committed to
                  protecting your personal information. This Privacy Policy
                  explains how we collect, use, disclose, and safeguard your
                  information when you use our services.
                </p>
              </div>
              <section className="space-y-4" data-id="element-416">
                <div className="flex items-start" data-id="element-417">
                  <div className="w-10 h-10 rounded-full bg-blue-primary/20 flex items-center justify-center mr-4 mt-1 flex-shrink-0" data-id="element-418">
                    <Shield size={18} className="text-blue-light" data-id="element-419" />
                  </div>
                  <div data-id="element-420">
                    <h2 className="text-xl font-bold mb-3 text-blue-light" data-id="element-421">
                      1. Information We Collect
                    </h2>
                    <p className="mb-3" data-id="element-422">
                      We may collect several types of information from and about
                      users of our services, including:
                    </p>
                    <ul className="list-disc pl-6 space-y-2 text-gray-300" data-id="element-423">
                      <li data-id="element-424">
                        Contact information (name, email address, phone number,
                        business name)
                      </li>
                      <li data-id="element-425">
                        Communication records and call recordings (with your
                        consent)
                      </li>
                      <li data-id="element-426">
                        Technical data (IP address, browser type, device
                        information)
                      </li>
                      <li data-id="element-427">Usage data (how you interact with our services)</li>
                      <li data-id="element-428">Marketing preferences</li>
                    </ul>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-429">
                  <div className="w-10 h-10 rounded-full bg-blue-primary/20 flex items-center justify-center mr-4 mt-1 flex-shrink-0" data-id="element-430">
                    <Eye size={18} className="text-blue-light" data-id="element-431" />
                  </div>
                  <div data-id="element-432">
                    <h2 className="text-xl font-bold mb-3 text-blue-light" data-id="element-433">
                      2. How We Use Your Information
                    </h2>
                    <p className="mb-3" data-id="element-434">
                      We use the information we collect to:
                    </p>
                    <ul className="list-disc pl-6 space-y-2 text-gray-300" data-id="element-435">
                      <li data-id="element-436">Provide and maintain our services</li>
                      <li data-id="element-437">Process and complete transactions</li>
                      <li data-id="element-438">Send administrative information</li>
                      <li data-id="element-439">Improve our services and customer experience</li>
                      <li data-id="element-440">Respond to inquiries and provide customer support</li>
                      <li data-id="element-441">Send marketing communications (with your consent)</li>
                      <li data-id="element-442">Monitor and analyze usage patterns and trends</li>
                    </ul>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-443">
                  <div className="w-10 h-10 rounded-full bg-blue-primary/20 flex items-center justify-center mr-4 mt-1 flex-shrink-0" data-id="element-444">
                    <Database size={18} className="text-blue-light" data-id="element-445" />
                  </div>
                  <div data-id="element-446">
                    <h2 className="text-xl font-bold mb-3 text-blue-light" data-id="element-447">
                      3. Data Storage and Security
                    </h2>
                    <p className="mb-3" data-id="element-448">
                      We implement appropriate technical and organizational
                      measures to protect your personal information against
                      unauthorized access, accidental loss, or destruction.
                      While we strive to use commercially acceptable means to
                      protect your personal information, we cannot guarantee its
                      absolute security.
                    </p>
                    <p data-id="element-449">
                      We retain your personal information only for as long as
                      necessary to fulfill the purposes for which we collected
                      it, including for the purposes of satisfying any legal,
                      accounting, or reporting requirements.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-450">
                  <div className="w-10 h-10 rounded-full bg-blue-primary/20 flex items-center justify-center mr-4 mt-1 flex-shrink-0" data-id="element-451">
                    <Lock size={18} className="text-blue-light" data-id="element-452" />
                  </div>
                  <div data-id="element-453">
                    <h2 className="text-xl font-bold mb-3 text-blue-light" data-id="element-454">
                      4. Information Sharing and Disclosure
                    </h2>
                    <p className="mb-3" data-id="element-455">We may share your information with:</p>
                    <ul className="list-disc pl-6 space-y-2 text-gray-300" data-id="element-456">
                      <li data-id="element-457">
                        Service providers who perform services on our behalf
                      </li>
                      <li data-id="element-458">Business partners with your consent</li>
                      <li data-id="element-459">
                        In response to legal requests or to protect our rights
                      </li>
                      <li data-id="element-460">
                        In connection with a business transaction such as a
                        merger or acquisition
                      </li>
                    </ul>
                    <p className="mt-3" data-id="element-461">
                      We do not sell your personal information to third parties.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-462">
                  <div className="w-10 h-10 rounded-full bg-blue-primary/20 flex items-center justify-center mr-4 mt-1 flex-shrink-0" data-id="element-463">
                    <Cookie size={18} className="text-blue-light" data-id="element-464" />
                  </div>
                  <div data-id="element-465">
                    <h2 className="text-xl font-bold mb-3 text-blue-light" data-id="element-466">
                      5. Cookies and Tracking Technologies
                    </h2>
                    <p className="mb-3" data-id="element-467">
                      We use cookies and similar tracking technologies to track
                      activity on our website and hold certain information.
                      Cookies are files with a small amount of data that may
                      include an anonymous unique identifier.
                    </p>
                    <p data-id="element-468">
                      You can instruct your browser to refuse all cookies or to
                      indicate when a cookie is being sent. However, if you do
                      not accept cookies, you may not be able to use some
                      portions of our service.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-469">
                  <div className="w-10 h-10 rounded-full bg-blue-primary/20 flex items-center justify-center mr-4 mt-1 flex-shrink-0" data-id="element-470">
                    <UserCheck size={18} className="text-blue-light" data-id="element-471" />
                  </div>
                  <div data-id="element-472">
                    <h2 className="text-xl font-bold mb-3 text-blue-light" data-id="element-473">
                      6. Your Rights
                    </h2>
                    <p className="mb-3" data-id="element-474">
                      Depending on your location, you may have certain rights
                      regarding your personal information, including:
                    </p>
                    <ul className="list-disc pl-6 space-y-2 text-gray-300" data-id="element-475">
                      <li data-id="element-476">Access to your personal information</li>
                      <li data-id="element-477">
                        Correction of inaccurate or incomplete information
                      </li>
                      <li data-id="element-478">Deletion of your personal information</li>
                      <li data-id="element-479">Restriction or objection to processing</li>
                      <li data-id="element-480">Data portability</li>
                      <li data-id="element-481">Withdrawal of consent</li>
                    </ul>
                    <p className="mt-3" data-id="element-482">
                      To exercise any of these rights, please contact us using
                      the information provided below.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-483">
                  <div className="w-10 h-10 rounded-full bg-blue-primary/20 flex items-center justify-center mr-4 mt-1 flex-shrink-0" data-id="element-484">
                    <Mail size={18} className="text-blue-light" data-id="element-485" />
                  </div>
                  <div data-id="element-486">
                    <h2 className="text-xl font-bold mb-3 text-blue-light" data-id="element-487">
                      7. Contact Us
                    </h2>
                    <p data-id="element-488">
                      If you have any questions about this Privacy Policy,
                      please contact us at:
                    </p>
                    <div className="mt-3 p-4 bg-gray-900/50 border border-gray-800 rounded-lg" data-id="element-489">
                      <p data-id="element-490">Callvana</p>
                      <p data-id="element-491">Email: info@callvanasolutions.com</p>
                      <p data-id="element-492">Phone: +1 (786) 577-7533</p>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-493" />
    </div>;
};